import { NgModule } from '@angular/core';
import { SharedModule } from '@core/modules/shared.module';
import { RouterModule } from '@angular/router';
import { AppLoginComponent } from './login.component';

import { RECAPTCHA_SETTINGS, RecaptchaSettings, RecaptchaModule } from 'ng-recaptcha';

const routes = [
    {
        path     : '',
        component: AppLoginComponent
    }
];

@NgModule({
    declarations: [
        AppLoginComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes),
        RecaptchaModule
    ],
    providers: [
        {
            provide: RECAPTCHA_SETTINGS,
            useValue: {
              siteKey: '6LfVXxEaAAAAAJV6PaJSvC3Ua7M37N5_CV-M7qG2',
            } as RecaptchaSettings,
        }
    ],
})

export class LoginModule
{

}
